import { useState } from "react";
import NewDefect from "./MobileNewDefectInfo.jsx";
import editImg from "../../assets/img/edit-pencil.svg";
import removeImg from "../../assets/img/close-circle.svg";
import { useNavigate } from "react-router-dom";
import arrowDownImg from "../../assets/img/arrow-down.svg";
import { useTranslation } from "react-i18next";

const Defect = ({
  title,
  isOpen,
  onClick,
  validate,
  defect,
  handleDefectChange,
  department,
  isBedek,
}) => {
  const { t } = useTranslation("applies");
  const navigate = useNavigate();

  const RemoveItem = () => {
    handleDefectChange({ ...defect, REMOVE: true });
  };

  const EditItem = () => {
    !!isBedek
      ? navigate("/bedek/mobile-new-defect", {
          state: { defect: defect, edit: true },
        })
      : navigate("/tenant/mobile-new-defect", {
          state: { defect: defect, edit: true },
        });
  };

  return (
    <div style={{ marginBottom: 5 }}>
      <div
        style={{
          cursor: "pointer",
          backgroundColor: "#ffffff",
          padding: 10,
          fontWeight: "bold",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 20,
            flex: "1 1 0%",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "flex-end",
            alignItems: "center",
            alignSelf: "center",
            margin: "auto",
            flexBasis: "100%",
          }}
        >
          <div>
            <img
              src={arrowDownImg}
              alt="toggle"
              onClick={onClick}
              style={{ transform: isOpen ? "rotate(0)" : "rotate(180deg)" }}
            />
          </div>
          <div>
            {t("defect")} {defect.index}
          </div>
          <div style={{ marginInlineStart: "auto" }}>
            <img src={editImg} alt="edit" onClick={EditItem} />
            <img
              src={removeImg}
              alt="del"
              style={{ marginInlineStart: 24 }}
              onClick={RemoveItem}
            ></img>
          </div>
        </div>
        {title}
      </div>
      {isOpen && (
        <NewDefect
          validate={validate}
          defect={defect}
          department={department}
          handleDefectChange={handleDefectChange}
        />
      )}
    </div>
  );
};

const DefectList = ({
  items,
  validate,
  handleDefectChange,
  department,
  isBedek,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div>
      {items.map((item, index) => (
        <div key={index}>
          {item.REMOVE !== true && (
            <Defect
              validate={validate}
              defect={items[index]}
              handleDefectChange={handleDefectChange}
              key={index}
              isBedek={isBedek}
              title={item.title}
              content={item.content}
              isOpen={openIndex === index}
              onClick={() => toggle(index)}
              department={department}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default DefectList;
